import { scheduleExportActions } from '../actions'
import { useActions, useAppSelector } from '../../../store/hooks'
import { exportSelector } from '../../../store/slices/export'
import { referencesSelector } from '../../../store/slices/references'
import { schedulePageSelector } from '../../../store/slices/schedulePage'

export function useScheduleExport() {
    const exportNotice = useAppSelector(exportSelector.notice)
    const isExporting = useAppSelector(exportSelector.isExporting)
    const exportModalOpen = useAppSelector(schedulePageSelector.exportModalOpen)
    const selectedExportGroupId = useAppSelector(schedulePageSelector.selectedExportGroupId)
    const selectedExportGroupName = useAppSelector(schedulePageSelector.selectedExportGroupName)
    const saveOnServer = useAppSelector(schedulePageSelector.saveOnServer)
    const groupOptions = useAppSelector(referencesSelector.groupOptions)

    const {
        scheduleExport,
        resetExportNotice,
        setExportGroup,
        setExportModalOpen,
        setSaveOnServer,
    } = useActions(scheduleExportActions)

    const openModal = () => {
        resetExportNotice()
        setExportModalOpen(true)
    }

    const closeModal = () => {
        setExportModalOpen(false)
    }

    const exportSchedule = () => {
        scheduleExport({
            groupId: selectedExportGroupId,
            groupName: selectedExportGroupName,
            saveOnServer,
        })
        setExportModalOpen(false)
    }

    const selectExportGroup = (value) => {
        const selected = groupOptions.find(
            (option) => String(option.value) === String(value)
        )

        setExportGroup({
            groupId: value,
            groupName: selected?.label || '',
        })
    }

    return {
        exportNotice,
        isExporting,
        exportModalOpen,
        selectedExportGroupId,
        saveOnServer,
        groupOptions,
        openModal,
        closeModal,
        exportSchedule,
        selectExportGroup,
        setSaveOnServer,
    }
}
